import type { RouteRecordRaw } from 'vue-router'
import { ROUTE_ROLES } from '@/utils/permissions'

const routes: RouteRecordRaw[] = [
  {
    path: '/inventory/receipts',
    name: 'InventoryReceipts',
    component: () => import('@/views/inventoryAdmin/index.vue'),
    meta: {
      title: '仓单管理',
      permission: 'inventory:manage',
      roles: ROUTE_ROLES.inventoryAdmin
    }
  },
  {
    path: '/inventory/quality-reports',
    name: 'QualityReports',
    component: () => import('@/views/inventoryAdmin/qualityReports.vue'),
    meta: {
      title: '质检报告',
      permission: 'inventory:manage',
      roles: ROUTE_ROLES.inventoryAdmin
    }
  }
]

export default routes
